import React from 'react';
import About from '../components/About';
import PageHero from '../components/PageHero';
import SEO from '../components/SEO';
import { useLanguage } from '../context/LanguageContext';
import { SITE_URL } from '../config/site';
import './PageStyles.css';

const AboutPage = () => {
  const { t } = useLanguage();

  return (
    <div className="page-container">
      <SEO
        title="About Dr. Muyabin | MCT Registered Dentist in Dar es Salaam"
        description="Learn about Dr. Muyabin — MCT registered dentist in Dar es Salaam with 5 years of experience, currently pursuing a Masters in Orthodontics."
        keywords="dentist Dar es Salaam, Dr Muyabin, MCT registered dentist Tanzania, orthodontics"
        url={`${SITE_URL}/about`}
      />
      <PageHero
        title={t('pages.aboutTitle')}
        subtitle={t('pages.aboutSubtitle')}
        breadcrumb={[
          { label: 'Home', href: '/' },
          { label: t('nav.about') },
        ]}
      />
      <About hideHeader />
    </div>
  );
};

export default AboutPage;
